<template>
  <div class="bg">
    <div class="container">
      <div class="header">
        <h1>
          {{
            $store.getters.userInfo.realname || $store.getters.userInfo.username
          }}
          人工智能核心素养档案查询页
        </h1>
        <!-- <a-divider></a-divider> -->
      </div>
      <div class="list-wrap">
        <a-row :gutter="[64]">
          <a-col :span="12" class="list-col">
            <!-- <h2></h2> -->
            <!-- <a-divider>AICE证书列表</a-divider> -->
            <div v-for="(d, i) in docList" :key="i">
              <a-alert type="info" style="max-width: 500px; margin: auto">
                <div slot="message">
                  <span>{{
                    d.eventParentCategory + " " + d.eventCategory
                  }}</span>
                  <a-button
                    :disabled="!d.awardGrant"
                    size="small"
                    @click="toCert(d.awardGrant.awardFile + '?t=' + new Date().getTime())"
                    >{{ d.awardGrant ? "下载" : "未开放" }}</a-button
                  >
                </div>
              </a-alert>
              <br />
            </div>
          </a-col>
          <a-col :span="12" class="list-col">
            <!-- <h2></h2> -->
            <!-- <a-divider>AICE人工智能核心素养评价报告</a-divider> -->
            <div v-for="(d, i) in docList" :key="i">
              <a-alert type="success" style="max-width: 500px; margin: auto">
                <div slot="message">
                  <span
                    >{{ d.eventParentCategory + " " + d.eventCategory }}
                  </span>
                  <a-button
                    :disabled="!d.canQueryScoreReport"
                    size="small"
                    @click="toReport(d.eventApplyId)"
                    >{{ d.canQueryScoreReport ? "查看" : "未开放" }}</a-button
                  >
                </div>
              </a-alert>
              <br />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";

export default {
  name: "AidocList",
  data() {
    return {
      docList: [],
    };
  },
  created() {
    this.getCert();
  },
  mounted() {
    let that = this;
    this.bodyScale();
    window.onresize = () => {
      that.bodyScale();
    };
  },
  methods: {
    bodyScale() {
      let devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
      let scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.body.style.zoom = scale; //放大缩小相应倍数
    },
    getCert() {
      let that = this;
      getAction("/teaching/teachingEventApply/queryMyCert")
        .then((res) => {
          this.docList = res.result;
        })
        .catch((e) => {
          if (
            e.response.status == 500 &&
            e.response.data.message.includes("Token失效")
          ) {
            this.$confirm({
              title: "未登录",
              content: "请先登录",
              okText: "去登录",
              onOk() {
                that.$router.push({
                  name: "aidoc",
                });
              },
            });
          }
        });
    },
    toCert(url) {
      window.open(url);
    },
    toReport(eventApplyId) {
      window.open("/cert/studentReport?eventApplyId=" + eventApplyId);
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  background: url(./listbg.jpg);
  min-height: 100vh;
  transform-origin: top;
}
.container {
  max-width: 1600px;
  margin: 0px auto;
  padding-top: 80px;
  .header {
    text-align: center;
    h1 {
      color: #fff;
    }
  }
  .list-wrap {
    margin-top: 64px;
    .list-col {
      max-height: 500px;
      overflow: auto;
    }
    .ant-btn{
      float: right;
    }
  }
}
</style>